import client from '../../base-api';

const serviceURL = '/assisted-living-coaching-overview';

const overviewAssistedLivingCoachingService = {
    getNewAndActiveList(filterData: any) {
        return client.get(`${serviceURL}/new-and-active`, {params: filterData});
    },
    getFinishedList(filterData: any) {
        return client.get(`${serviceURL}/finished`, {params: filterData});
    },
    getArchivedList(filterData: any) {
        return client.get(`${serviceURL}/archived`, {params: filterData});
    },

}
export default overviewAssistedLivingCoachingService;